import { Image } from '@com-delta-idp/mnx-ui-kit';
import { AnalyticsEvent, GenericLabel } from '@com-delta-idp/mnx-utils';
import { Actions } from './benefits.interfaces';

export interface AemWelcomeTourAriaLabels {
  closeTour: string;
  action: Actions;
}

export interface AEMSlide {
  desktopImage: Image;
  mobileImage: Image;
  content: GenericLabel;
}

export interface AEMWelcomeTourContent {
  header: string;
  slides: AEMSlide[];
  analyticsEvent: AnalyticsEvent;
  ariaLabels: AemWelcomeTourAriaLabels;
}

export interface AEMWelcomeTour {
  tour: AEMWelcomeTourContent;
}
